import { Injectable } from '@angular/core';
import { type } from 'os';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})

export class ControlQrService {
    constructor(private http: HttpClient) { }

    private _parentData = new BehaviorSubject<Object>({});
    parentData = this._parentData.asObservable();

    private _studentData = new BehaviorSubject<Object>({});
    studentData = this._studentData.asObservable();

    private _regenerateUserData = new BehaviorSubject<Object>({});
    regenerateUserData = this._regenerateUserData.asObservable();

    setParentData(parent, type) {
        this._parentData.next({ 'parent': parent, 'type': type });
    }

    getParentData() {
        return this._parentData;
    }
    
    setStudentData(student, type) {
        this._studentData.next({ 'student': student, 'type': type });
    }

    getStudentData() {
        return this._studentData;
    }

    setRegenerateUserData(user) {
        this._regenerateUserData.next(user);
    }

    getRegenerateUserData() {
        return this._regenerateUserData;
    }

    private _parentsData = new BehaviorSubject<Object>({});
    parentsData = this._parentData.asObservable();

    setParentsData(noOfParents, type) {
        this._parentData.next({ 'noOfParents': noOfParents, 'type': type });
    }

    getParentsData() {
        return this._parentData;
    }

    private _studentsData = new BehaviorSubject<Object>({});
    studentsData = this._studentData.asObservable();

    setStudentsData(noOfStudents, type) {
        this._studentData.next({ 'noOfStudents': noOfStudents, 'type': type });
    }

    getStudentsData() {
        return this._studentData;
    }

    private _qrRevampObj = new BehaviorSubject<Object>({
     selected:[],
     type:'',
     showPrint:false
    });
    qrRevampObj = this._qrRevampObj.asObservable();

    setQrRevampObj(qrObj) {
        this._qrRevampObj.next(qrObj);
    }

    getQrRevampObj() {
        return this._qrRevampObj;
    }

    printQr(body, user) {
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/${user}/qr/pdf`, body);
    }
}